import { includes } from '../helpers';
class TargetSelector {
  constructor(ctx) {
    this.file = null;
    this.store = ctx.$store;
    this.ctx = ctx;
    this.targetObject = null;
    this.info = this.store.state.info;
    this.ext = '';
    this.targetForExt = this.store.state.advancedSetting.targetForExt;
    this.enablePreiview = this.info.active === "PreviewTemplate" || (this.info.customVariables
      ? this.info.customVariables.enablePreview
      : false)
  }

  setFile(file) {
    this.file = file;
    this.ext = this.file.ext;
    return this;
  }

  async setTargetForFile(target, initial = false) {
    if (!target) return null;
    const targetExt = target === 'string' ? target : target.ext;
    this.targetObject = target.slug ? target : {
      ...this.store.state.advancedSetting.targetObjects[targetExt],
    };
    const targetType = this.targetObject && this.targetObject.type ? this.targetObject.type : (target.type ? target.type : this.getType(targetExt));
    const defaultType = this.store.state.info.type;

    const targetForFile = {
      ...this.targetObject,
      ready: true,
      uid: this.file.id,
      ext: this.targetObject && this.targetObject.ext ? this.targetObject.ext : targetExt,
      type: targetType || defaultType,
      targetType: targetType
    }
    this.store.commit('advancedSetting/setTargetForFile', targetForFile);
    await this.setOptions(targetForFile.ext, initial);
    this.store.commit('advancedSetting/resetSelectionToRoot', {id: this.file.id, slug: `${this.file.ext}-to-${targetExt}`})
    this.store.commit('advancedSetting/setConversionType', { key: this.file.id, type: `${this.file.ext}-to-${targetExt}` });

    return targetForFile;
  }

  getType(ext, actual) {
    let t = '';
    let item;
    for (const type in this.targetForExt[this.file.ext]) {
      item = includes(
        this.targetForExt[this.file.ext][type],
        'name',
        ext ? ext.toLowerCase() : ''
      );
      if (item) {
        t = actual ? type : item.type || type;
      }
    }
    return t;
  }

  async setOptions(ext, initial = false) {
    if (
      (!this.info.toolPage &&
        (!this.info.customVariables ||
        (this.info.customVariables && !this.info.customVariables.targets))
      ) ||
      (
        this.info.toolPage &&
        this.info.customVariables &&
        this.info.customVariables.useIndividualAdvancedOptions
      )
    ) {
      const perConversionType =
        this.store.state.advancedSetting.perConversionType;
      const key = `${this.file.ext}-to-${ext}`;
      /**
       * In most preview pages, our system allows only specific
       * file exts. Which is covered by the advanced options
       * that comes with the page API. However in cases where
       * files may have duplicate exts(like .jpg, .jpeg), out 
       * system would make 2 different sets of API calls and 
       * manage 2 different sets options/selections. This 
       * check is to prvent that.
       */
      if(this.enablePreiview && this.store.state.advancedSetting.merging) return

      if (perConversionType[key]) {
        this.store.commit('advancedSetting/setInitialUserData', key);
        this.store.commit('advancedSetting/initialCopySelection', { from: 'root', to: this.file.id });
      } else {
        await this.store.dispatch('advancedSetting/setOptions', {
          srcType: this.file.type,
          srcExt: this.file.ext,
          targetType: this.getType(ext, true),
          targetExt: ext,
          lang: this.ctx.$i18n.locale,
          file: this.file,
          initial: initial,
          operation: this.info.toolPage && this.info?.customVariables?.useIndividualAdvancedOptions ? this.info.operation: undefined,
        });
      }
    }
  }
}

export default TargetSelector;
